import React from "react";
import { Box, Typography } from "@mui/material";
import type { InteractiveStyleKit } from "./interactive-style-kit";
import { interactiveRootSx } from "./styles";

interface QuestionHeaderProps {
  title?: string;
  instruction?: string;
  prompt?: string;
  styles: Pick<InteractiveStyleKit, "titleSx" | "instructionSx" | "promptSx">;
}

export const QuestionHeader: React.FC<QuestionHeaderProps> = ({
  title,
  instruction,
  prompt,
  styles,
}) => (
  <Box sx={{ ...interactiveRootSx, gap: 0.75, py: 0 }}>
    {title ? (
      <Typography component="h3" sx={styles.titleSx}>
        {title}
      </Typography>
    ) : null}
    {instruction ? (
      <Typography sx={styles.instructionSx}>{instruction}</Typography>
    ) : null}
    {prompt ? (
      <Typography sx={styles.promptSx}>{prompt}</Typography>
    ) : null}
  </Box>
);
